import { render } from "./AppointmentCreateModal.vue?vue&type=template&id=5c36d0e0&scoped=true&ts=true"
import script from "./AppointmentCreateModal.vue?vue&type=script&lang=ts"
export * from "./AppointmentCreateModal.vue?vue&type=script&lang=ts"

import "./AppointmentCreateModal.vue?vue&type=style&index=0&id=5c36d0e0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c36d0e0"]])

export default __exports__